export interface ColorSettings {
  borderColor?: string
  backgroundColor?: string
  primaryBackgroundColor?: string
  entryBackgroundColor?: string
  buttonColor?: string
  buttonTextColor?: string
  primaryTextColor?: string
  secondaryTextColor?: string
  actionTextColor?: string
  gradientStart?: string
  gradientEnd?: string
  hoverGradientStart?: string
  hoverGradientEnd?: string
  leaderboardDetailsBg?: string
  leaderboardItemBg?: string
  leaderboardWinnerBorder?: string
  winPercentageBg?: string
  winPercentageBorder?: string
  winPercentageText?: string
  iconColor?: string
  leaderboardSecondaryColor?: string
  iconBgColor?: string
  entryActionBorderRadius?: string
  iconBorderRadius?: string
  entryButtonBorderRadius?: string
  statsSectionBorderRadius?: string
}

export const defaultColorSettings: ColorSettings = {
  borderColor: "#fef08a", // yellow-200
  primaryBackgroundColor: "#ffffff", // white
  entryBackgroundColor: "#f3f4f6", // bg-gray-100
  buttonColor: "#000000", // black
  buttonTextColor: "#ffffff", // white
  primaryTextColor: "#111827", // gray-900
  secondaryTextColor: "#6b7280", // gray-500
  actionTextColor: "#111827", // gray-900
  gradientStart: "#fffbeb", // yellow-50
  gradientEnd: "#fff7ed", // orange-50
  hoverGradientStart: "#fef3c7", // yellow-100
  hoverGradientEnd: "#ffedd5", // orange-100
  leaderboardDetailsBg: "#f9fafb", // bg-gray-100
  leaderboardItemBg: "#f3f4f6", // bg-gray-100
  leaderboardWinnerBorder: "#fcd34d", // yellow-300
  winPercentageBg: "#eff6ff", // blue-50
  winPercentageBorder: "#bfdbfe", // blue-200
  winPercentageText: "#1e40af", // blue-800
  iconColor: "#374151", // gray-700
  leaderboardSecondaryColor: "#ca8a04", // yellow-600
  iconBgColor: "#e5e7eb", // gray-200
  entryActionBorderRadius: "8px", // rounded-lg
  iconBorderRadius: "8px", // rounded-lg
  entryButtonBorderRadius: "6px", // rounded-md
  statsSectionBorderRadius: "8px", // rounded-lg
}